<app-country-currency-hero [pageData]="pageData"></app-country-currency-hero>
<app-common-companies-panel [companiesData]="companiesData"></app-common-companies-panel>
<app-country-currency-feature [pageData]="pageData"></app-country-currency-feature>
<app-country-currency-exchange-rate [pageData]="pageData"></app-country-currency-exchange-rate>
<app-country-currency-subscribe-form></app-country-currency-subscribe-form>
<app-country-currency-coverage [pageData]="pageData"></app-country-currency-coverage>
<app-common-latest-news [blogData]="newsList"></app-common-latest-news>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
